import { flattenReduxFormProps } from 'decorators';
import { Input } from 'components/core/Input';

export default flattenReduxFormProps(Input);
